import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDate from "../../../modules/SimpleDate";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleMonthYearPicker from "../../../modules/SimpleMonthYearPicker";
import SimpleDDL from "../../../modules/SimpleDDL";
import { fetchDataAsync } from "../../../Services/Utils";
import Api from "../../../Services/Api";
import { HttpStatus, Status } from "../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../common/mapper";
import moment from "moment";
import SimpleMonthYearPickerWithIcon, { convertToDateObject } from "../../../modules/SimpleMonthYearPickerWithIcon";

class PoPartFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        noPo: null,
        startDate: null,
        endDate: null,
        monthYear: null,
      },
      partCategoryOptions: [],
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  handleValueChange = (name, value) => {
    console.log(name, value);

    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  handleReset = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filter: {
        noPo: null,
        startDate: null,
        endDate: null,
        monthYear: null,
        partCategory: null,
      },
    }));
  };

  loadDDL = async () => {
    const { onTriggerLoading, setError, submitedFilter } = this.props;
    onTriggerLoading();
    if (submitedFilter) {
      this.setState({
        filter: {
          ...submitedFilter,
          monthYear: submitedFilter.monthYear
            ? convertToDateObject(submitedFilter.monthYear)
            : null,
        },
      });
    }

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
      menuName: "PO Part",
      setError,
      args: {
        paramFilters: {
          bizparCategory: "PART_TYPE",
          status: Status.ACTIVE,
        },
      },
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        partCategoryOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.value, item.key)
        ),
      });
    }
    onTriggerLoading();
  };

  handleSubmit = () => {
    const { onSubmit, onClickClose } = this.props;
    const { filter } = this.state;
    const submitFilter = {
      ...filter,
      monthYear: filter.monthYear ? filter.monthYear.format("MMMM YYYY") : null,
    };

    onSubmit(submitFilter);
    onClickClose();
  };

  render() {
    const { onClickClose, visible } = this.props;
    const { partCategoryOptions, filter } = this.state;
    return (
      <SimpleModal
        title="Filter Search"
        visible={visible}
        onClickClose={onClickClose}
        content={
          <ModalContainer>
            <SimpleInput
              id="input_text_po_no"
              name="noPo"
              label="PO No."
              value={filter?.noPo}
              onChange={({ target }) =>
                this.handleValueChange(target.name, target.value)
              }
            />
            <FlexView column vAlignContent="center">
              <div className="txt-site txt-11 txt-main txt-bold">
                <h4>Tanggal PO:</h4>
              </div>
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <div style={{ width: "100%" }}>
                  <SimpleDate
                    id="select_date_tglmutasi_from"
                    name="startDate"
                    nextdate
                    date={filter.startDate}
                    maxDate={filter.endDate}
                    onChange={(value) =>
                      this.handleValueChange(
                        "startDate",
                        moment(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                </div>
                <span className="margin-bottom-20px">s/d</span>
                <div style={{ width: "100%" }}>
                  <SimpleDate
                    id="select_date_tglmutasi_to"
                    name="endDate"
                    nextdate
                    date={filter.poDate?.endDate}
                    onChange={(value) =>
                      this.handleValueChange(
                        "endDate",
                        moment(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                </div>
              </FlexView>
            </FlexView>
            <div className="full-month-year-picker-width">
              <SimpleMonthYearPickerWithIcon
                id="select_date_month_year"
                label="Bulan Purchase Order"
                name="monthYear"
                value={filter?.monthYear}
                onFocusedDateChange={(value) => {
                  console.log(value);
                  if (!value) return;
                  this.handleValueChange("monthYear", value);
                }}
              />
            </div>
            <SimpleDDL
              id="category_part_dropdown"
              box="search"
              name="partCategory"
              label="Kategori Part"
              options={partCategoryOptions}
              value={filter?.partCategory}
              onChange={(value, { name }) =>
                this.handleValueChange(name, value)
              }
            />
            <FlexView hAlignContent="right" style={{ gap: "10px" }}>
              <SimpleButton type="button" onClick={this.handleReset}>
                Clear
              </SimpleButton>
              <SimpleButton onClick={() => this.handleSubmit()}>
                Terapkan
              </SimpleButton>
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default PoPartFilter;
